/**
 * Organizer pattern gallery (spec 016).
 * Switches between the three shirt design patterns and renders a locally
 * selected logo (object URL, never uploaded) into the chosen tier's zones on
 * the active pattern diagram. Without JS the section shows all patterns
 * stacked and no try-a-logo controls.
 */
(() => {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const PREVIEWABLE_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];
  const ZONE_PADDING = 1.5;
  const PATTERN_TIERS = {
    classic: ['title', 'gold', 'silver', 'bronze'],
    'community-grid': ['gold', 'silver', 'bronze'],
    premium: ['title', 'gold'],
  };
  const PATTERN_NAMES = {
    classic: 'Classic',
    'community-grid': 'Community Grid',
    premium: 'Premium Minimal',
  };

  const tierName = (tier) => tier.charAt(0).toUpperCase() + tier.slice(1);

  document.querySelectorAll('[data-pattern-gallery]').forEach((gallery) => {
    const switcher = gallery.querySelector('[data-pattern-switch]');
    const tryBlock = gallery.querySelector('[data-pattern-try]');
    const fileInput = gallery.querySelector('[data-pattern-file]');
    const tierSelect = gallery.querySelector('[data-pattern-tier]');
    const status = gallery.querySelector('[data-pattern-status]');
    const cta = gallery.querySelector('[data-pattern-cta]');
    const panels = gallery.querySelectorAll('[data-pattern-panel]');

    if (!switcher || !tryBlock || !fileInput || !tierSelect || !panels.length) return;

    let objectUrl = null;
    let previewable = false;
    let fileName = '';

    const activePattern = () => {
      const radio = switcher.querySelector('input:checked');
      return radio ? radio.value : 'classic';
    };

    const setStatus = (text) => {
      if (!status) return;
      status.textContent = text || '';
      status.hidden = !text;
    };

    const clearRender = () => {
      gallery.querySelectorAll('.tier-placement__logo-preview').forEach((el) => el.remove());
    };

    const render = () => {
      clearRender();
      const pattern = activePattern();
      const tier = tierSelect.value;
      const panel = gallery.querySelector('[data-pattern-panel="' + pattern + '"]');
      if (!panel || !objectUrl || !previewable) return;

      panel.querySelectorAll('[data-tier-zone="' + tier + '"]').forEach((zone) => {
        const svg = zone.ownerSVGElement;
        if (!svg) return;
        const x = parseFloat(zone.getAttribute('x')) + ZONE_PADDING;
        const y = parseFloat(zone.getAttribute('y')) + ZONE_PADDING;
        const width = parseFloat(zone.getAttribute('width')) - ZONE_PADDING * 2;
        const height = parseFloat(zone.getAttribute('height')) - ZONE_PADDING * 2;

        const backing = document.createElementNS(SVG_NS, 'rect');
        backing.setAttribute('x', x);
        backing.setAttribute('y', y);
        backing.setAttribute('width', width);
        backing.setAttribute('height', height);
        backing.setAttribute('rx', 2);
        backing.setAttribute('fill', '#ffffff');
        backing.classList.add('tier-placement__logo-preview');

        const image = document.createElementNS(SVG_NS, 'image');
        image.setAttribute('href', objectUrl);
        image.setAttribute('x', x);
        image.setAttribute('y', y);
        image.setAttribute('width', width);
        image.setAttribute('height', height);
        image.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        image.classList.add('tier-placement__logo-preview');

        svg.appendChild(backing);
        svg.appendChild(image);
      });
    };

    const syncTierOptions = (pattern) => {
      const tiers = PATTERN_TIERS[pattern] || PATTERN_TIERS.classic;
      let selectionValid = false;
      Array.from(tierSelect.options).forEach((option) => {
        const available = tiers.includes(option.value);
        option.disabled = !available;
        if (available && option.value === tierSelect.value) selectionValid = true;
      });
      if (!selectionValid) tierSelect.value = tiers[0];
    };

    const update = () => {
      const pattern = activePattern();
      panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-pattern-panel') !== pattern;
      });
      syncTierOptions(pattern);
      if (cta) cta.href = '/pages/organizer-intake?pattern=' + pattern;
      render();

      if (objectUrl && previewable) {
        setStatus('Previewing your logo in the ' + tierName(tierSelect.value) + ' position on the ' + PATTERN_NAMES[pattern] + ' pattern. Final sizing is confirmed during proofing.');
      } else if (fileName && !previewable) {
        setStatus(fileName + ' attached. Preview isn’t available for this file type — SponsorTee positions it during proofing.');
      } else {
        setStatus('');
      }
    };

    fileInput.addEventListener('change', () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
      previewable = false;
      fileName = '';

      const file = fileInput.files && fileInput.files[0];
      if (file) {
        fileName = file.name;
        if (PREVIEWABLE_TYPES.includes(file.type)) {
          objectUrl = URL.createObjectURL(file);
          previewable = true;
        }
      }
      update();
    });

    switcher.addEventListener('change', update);
    tierSelect.addEventListener('change', update);

    switcher.hidden = false;
    tryBlock.hidden = false;
    update();
  });
})();
